"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _OptionalItem = _interopRequireDefault(require("./OptionalItem"));

var _BundlePage = require("../BundlePage");

var _AddonBundleRestrictionsMap = _interopRequireDefault(require("pricing-pages-unified-ui/constants/AddonBundleRestrictionsMap"));

function AddOnItem(_ref) {
  var merchandiseId = _ref.merchandiseId;

  var _useContext = (0, _react.useContext)(_BundlePage.BundleContext),
      state = _useContext.state,
      setState = _useContext.setState;

  var selectedAddOns = state.selectedAddOns;
  var bundleRestriction = _AddonBundleRestrictionsMap.default[merchandiseId];
  var restricted = (0, _reactRedux.useSelector)(function (reduxState) {
    return bundleRestriction && bundleRestriction.isRestricted(state, reduxState);
  });
  var restrictionKey = bundleRestriction && bundleRestriction.restrictionKey;
  var onSelectedChange = (0, _react.useCallback)(function () {
    var updatedSelectedAddons = selectedAddOns.includes(merchandiseId) ? selectedAddOns.filter(function (id) {
      return id !== merchandiseId;
    }) : [].concat((0, _toConsumableArray2.default)(selectedAddOns), [merchandiseId]);
    setState({
      selectedAddOns: updatedSelectedAddons
    });
  }, [setState, merchandiseId, selectedAddOns]);
  return _react.default.createElement(_OptionalItem.default, {
    selected: selectedAddOns.includes(merchandiseId),
    onSelectedChange: onSelectedChange,
    merchandiseId: merchandiseId,
    restricted: restricted,
    restrictionKey: restrictionKey
  });
}

var _default = AddOnItem;
exports.default = _default;
module.exports = exports.default;